var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlasuj(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1690",
    "data-name": "Group 1690",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 65,
    height: 99.134,
    viewBox: "0 0 65 99.134",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2711",
    "data-name": "Rectangle 2711",
    width: 54.536,
    height: 54.788,
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2688",
    "data-name": "Rectangle 2688",
    width: 65,
    height: 99.134,
    rx: 10,
    transform: "translate(0 0)",
    fill: "#7ca0fc"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2689",
    "data-name": "Rectangle 2689",
    width: 48.917,
    height: 69.654,
    transform: "translate(0 19.043)",
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2690",
    "data-name": "Rectangle 2690",
    width: 37.6,
    height: 0.977,
    transform: "translate(0 21.594)",
    fill: "#99b9ff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2691",
    "data-name": "Rectangle 2691",
    width: 38.791,
    height: 0.977,
    transform: "translate(0 23.381)",
    fill: "#99b9ff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2692",
    "data-name": "Rectangle 2692",
    width: 14.17,
    height: 0.977,
    transform: "translate(0 25.168)",
    fill: "#99b9ff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2693",
    "data-name": "Rectangle 2693",
    width: 38.791,
    height: 0.977,
    transform: "translate(0 28.742)",
    fill: "#99b9ff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2694",
    "data-name": "Rectangle 2694",
    width: 38.791,
    height: 0.977,
    transform: "translate(0 30.529)",
    fill: "#99b9ff"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2695",
    "data-name": "Rectangle 2695",
    width: 37.203,
    height: 0.977,
    transform: "translate(0 32.316)",
    fill: "#99b9ff"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2696",
    "data-name": "Rectangle 2696",
    width: 38.394,
    height: 0.976,
    transform: "translate(0 34.103)",
    fill: "#99b9ff"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2697",
    "data-name": "Rectangle 2697",
    width: 7.618,
    height: 0.977,
    transform: "translate(0 35.89)",
    fill: "#99b9ff"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2698",
    "data-name": "Rectangle 2698",
    width: 38.791,
    height: 0.977,
    transform: "translate(0 39.464)",
    fill: "#99b9ff"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2699",
    "data-name": "Rectangle 2699",
    width: 38.195,
    height: 0.977,
    transform: "translate(0 41.251)",
    fill: "#99b9ff"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2700",
    "data-name": "Rectangle 2700",
    width: 38.791,
    height: 0.977,
    transform: "translate(0 43.038)",
    fill: "#99b9ff"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2701",
    "data-name": "Rectangle 2701",
    width: 38.791,
    height: 0.977,
    transform: "translate(0 44.825)",
    fill: "#99b9ff"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2702",
    "data-name": "Rectangle 2702",
    width: 37.997,
    height: 0.977,
    transform: "translate(0 46.612)",
    fill: "#99b9ff"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2703",
    "data-name": "Rectangle 2703",
    width: 38.791,
    height: 0.976,
    transform: "translate(0 48.399)",
    fill: "#99b9ff"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2704",
    "data-name": "Rectangle 2704",
    width: 37.6,
    height: 0.976,
    transform: "translate(0 50.186)",
    fill: "#99b9ff"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2705",
    "data-name": "Rectangle 2705",
    width: 38.791,
    height: 0.976,
    transform: "translate(0 51.973)",
    fill: "#99b9ff"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2706",
    "data-name": "Rectangle 2706",
    width: 37.798,
    height: 0.977,
    transform: "translate(0 53.759)",
    fill: "#99b9ff"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2707",
    "data-name": "Rectangle 2707",
    width: 1.264,
    height: 0.976,
    transform: "translate(0 55.547)",
    fill: "#99b9ff"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2708",
    "data-name": "Rectangle 2708",
    width: 1.264,
    height: 0.977,
    transform: "translate(0 67.658)",
    fill: "#99b9ff"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2709",
    "data-name": "Rectangle 2709",
    width: 38.791,
    height: 0.977,
    transform: "translate(0 59.121)",
    fill: "#99b9ff"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2710",
    "data-name": "Rectangle 2710",
    width: 36.011,
    height: 0.976,
    transform: "translate(0 60.908)",
    fill: "#99b9ff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1573",
    "data-name": "Group 1573",
    transform: "translate(10.464 29.365)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1572",
    "data-name": "Group 1572",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2915",
    "data-name": "Path 2915",
    d: "M281.935,348.137l.213,10.914,1.067-.021a3.538,3.538,0,0,0,3.468-3.606L286.557,349Z",
    transform: "translate(-255.576 -317.149)",
    fill: "#587be1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2916",
    "data-name": "Path 2916",
    d: "M262.036,350.784l-4.661,9.871.965.456a3.538,3.538,0,0,0,4.709-1.688l2.745-5.813Z",
    transform: "translate(-236.552 -319.199)",
    fill: "#587be1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2917",
    "data-name": "Path 2917",
    d: "M206.4,315.147l6.309-6.561,9.494,9.129a13.141,13.141,0,0,0,9.365,3.666l4.464.33L250.9,334.585l8.232-14.28-13.69-8.4-19.615-13.688L212.885,301.2l-12.744,13.253.834.8a3.837,3.837,0,0,0,5.425-.106",
    transform: "translate(-192.22 -278.48)",
    fill: "#587be1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2918",
    "data-name": "Path 2918",
    d: "M243.594,349.541l-7.566,7.868.769.74a3.537,3.537,0,0,0,5-.1l4.456-4.634Z",
    transform: "translate(-220.017 -318.236)",
    fill: "#587be1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2919",
    "data-name": "Path 2919",
    d: "M194.8,391.4a24.1,24.1,0,0,1,1.673-1.741,5.774,5.774,0,0,1-1.116-.873,5.889,5.889,0,0,1-.881-1.11,24.08,24.08,0,0,1-1.724,1.689,23.392,23.392,0,0,1-1.882,1.511c.281.8-.518,2.449-1.975,4.055l.129.129.02-.019,2.856-2.885a.243.243,0,0,1,.007-.3.3.3,0,0,1,.412.412.243.243,0,0,1-.3.008l-2.855,2.884-.02.02.129.128c1.592-1.474,3.232-2.284,4.031-2.012a23.615,23.615,0,0,1,1.494-1.9",
    transform: "translate(-183.508 -347.774)",
    fill: "#99b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2920",
    "data-name": "Path 2920",
    d: "M197.925,390.64c.569-.5,1.088-.994,1.554-1.479l.559.559-4.642,4.642a4.145,4.145,0,0,0,.692-2.276l.723-.533c.365-.282.737-.585,1.113-.913",
    transform: "translate(-188.545 -348.925)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2921",
    "data-name": "Path 2921",
    d: "M204.969,394.683a6.338,6.338,0,0,1-.631-.524l-2.723,2.723a.542.542,0,0,1-.027.661.466.466,0,0,1-.407.118l-.645.652a2.914,2.914,0,0,1,1.6-.352c.429-.6.9-1.2,1.414-1.781.462-.53.938-1.033,1.416-1.5",
    transform: "translate(-192.526 -352.796)",
    fill: "#99b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2922",
    "data-name": "Path 2922",
    d: "M229.3,305.706c-6.5,6.492-12.372,12.543-17.039,17.484l1.367,1.368c4.941-4.667,10.991-10.539,17.484-17.039q1.271-1.273,2.518-2.528l-1.8-1.8q-1.254,1.247-2.528,2.519",
    transform: "translate(-201.611 -282.331)",
    fill: "#fccc42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2923",
    "data-name": "Path 2923",
    d: "M298.826,251.282c5.526-5.6,10.583-10.955,14.691-15.521l-3.136-3.136c-4.565,4.107-9.916,9.165-15.52,14.691Z",
    transform: "translate(-265.587 -227.676)",
    fill: "#fccc42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2924",
    "data-name": "Path 2924",
    d: "M301.187,252.947c5.545-5.586,10.674-10.864,14.894-15.318l-1.6-1.6c-4.454,4.219-9.732,9.349-15.318,14.894Z",
    transform: "translate(-268.918 -230.31)",
    fill: "#fccc42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2925",
    "data-name": "Path 2925",
    d: "M226.55,301.063c-6.373,6.618-12.037,12.879-16.533,17.989l2.381,2.38c5.111-4.5,11.37-10.16,17.989-16.533q1.3-1.248,2.563-2.483l-3.916-3.916q-1.235,1.268-2.483,2.563",
    transform: "translate(-199.87 -278.701)",
    fill: "#fccc42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2926",
    "data-name": "Path 2926",
    d: "M229.488,305.291c-6.433,6.559-12.244,12.672-16.89,17.633l1.217,1.218c4.961-4.647,11.074-10.456,17.633-16.889q1.284-1.26,2.544-2.5l-2-2q-1.243,1.259-2.5,2.544",
    transform: "translate(-201.869 -281.99)",
    fill: "#fccc42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2927",
    "data-name": "Path 2927",
    d: "M364.04,225.26l2.988,2.988c.781-.863,1.531-1.7,2.24-2.5a4.019,4.019,0,0,0-2.724-2.723c-.8.709-1.641,1.459-2.5,2.24",
    transform: "translate(-319.172 -220.236)",
    fill: "#99b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2928",
    "data-name": "Path 2928",
    d: "M365.163,226.528l1.975,1.975c.764-.819,1.5-1.613,2.2-2.372a1.948,1.948,0,0,0-1.8-1.8c-.759.7-1.553,1.433-2.372,2.2",
    transform: "translate(-320.042 -221.251)",
    fill: "#99b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2929",
    "data-name": "Path 2929",
    d: "M369.39,225.509l-.607-.607h0c-.766.746-1.57,1.53-2.4,2.343l.666.666c.813-.831,1.6-1.635,2.343-2.4h0",
    transform: "translate(-320.986 -221.694)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2930",
    "data-name": "Path 2930",
    d: "M363.635,231.805l3.157,3.157.234-.26-3.131-3.131-.26.234",
    transform: "translate(-318.859 -226.859)",
    fill: "#99b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2931",
    "data-name": "Path 2931",
    d: "M371.406,239.545l.962.962.243-.251-.954-.954-.251.243",
    transform: "translate(-324.878 -232.847)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2932",
    "data-name": "Path 2932",
    d: "M365.039,233.173l.54.54.245-.249-.536-.536-.249.245",
    transform: "translate(-319.946 -227.91)",
    fill: "#99b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2933",
    "data-name": "Path 2933",
    d: "M293.433,295.86l4.015,4.014.916-.949-3.982-3.982-.949.916",
    transform: "translate(-264.482 -275.946)",
    fill: "#99b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2934",
    "data-name": "Path 2934",
    d: "M299.581,301.98l2.065,2.065.924-.941-2.048-2.048-.941.924",
    transform: "translate(-269.244 -280.681)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2935",
    "data-name": "Path 2935",
    d: "M311.022,274.966c-.111-.111-.362-.039-.561.16a.708.708,0,0,0-.2.342c0-.006,0-.014-.009-.019-.071-.071-.2,0-.33.129s-.206.264-.135.335.233.008.375-.037a1.827,1.827,0,0,0,.7-.349c.2-.2.271-.45.16-.561",
    transform: "translate(-277.13 -260.432)",
    fill: "#99b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2936",
    "data-name": "Path 2936",
    d: "M321.456,228.61a1.064,1.064,0,0,0-1.475-.171L309.5,238.924s-.358.507-.049.816c.179.179,10.784-11.048,10.784-11.048a.738.738,0,0,1,1.021.119.994.994,0,0,1,.13.165l.206-.206a1.445,1.445,0,0,0-.136-.159",
    transform: "translate(-276.792 -224.257)",
    fill: "#99b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2937",
    "data-name": "Path 2937",
    d: "M322.631,229.734a1.064,1.064,0,0,0-1.475-.171l-10.641,10.645.253.253,10.641-10.645a.738.738,0,0,1,1.021.119.991.991,0,0,1,.13.165l.206-.206a1.447,1.447,0,0,0-.136-.159",
    transform: "translate(-277.713 -225.128)",
    fill: "#99b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2938",
    "data-name": "Path 2938",
    d: "M323.73,230.55a.751.751,0,0,0-1-.1l-10.493,10.493.065.065c.005-.006.008-.013.013-.018l10.427-10.427a.738.738,0,0,1,1.021.119.992.992,0,0,1,.13.165l.03-.029a1.029,1.029,0,0,0-.194-.27",
    transform: "translate(-279.047 -225.878)",
    fill: "#99b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2939",
    "data-name": "Path 2939",
    d: "M310.88,275.36c-.111-.111-.348-.053-.53.129a.608.608,0,0,0-.176.319c0-.005,0-.013-.009-.018-.072-.071-.154-.1-.271.016s-.27.294-.154.41c.071.071.223.018.357-.02a1.582,1.582,0,0,0,.654-.306c.182-.182.24-.42.129-.53",
    transform: "translate(-277.08 -260.733)",
    fill: "#99b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2940",
    "data-name": "Path 2940",
    d: "M253.788,349.626l-15.567.3.007.08a5.408,5.408,0,0,0,4.8,4.885l7.263,1.22,2.527,2.427",
    transform: "translate(-221.716 -318.302)",
    fill: "#587be1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2941",
    "data-name": "Path 2941",
    d: "M253.788,349.626l-15.567.3.007.08a5.408,5.408,0,0,0,4.8,4.885l7.263,1.22,2.527,2.427",
    transform: "translate(-221.716 -318.302)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_88",
    "data-name": "Line 88",
    x1: 1.743,
    y2: 3.059,
    transform: "translate(21.468 36.962)",
    fill: "#587be1"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_89",
    "data-name": "Line 89",
    x1: 1.743,
    y2: 3.059,
    transform: "translate(21.468 36.962)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_90",
    "data-name": "Line 90",
    x2: 0.067,
    y2: 2.488,
    transform: "translate(26.479 37.527)",
    fill: "#587be1"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_91",
    "data-name": "Line 91",
    x2: 0.067,
    y2: 2.488,
    transform: "translate(26.479 37.527)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlasuj);
export default __webpack_public_path__ + "static/media/glasuj.fd87473a140e6192fed669bc6aa07039.svg";
export { ForwardRef as ReactComponent };